import { t } from "@lingui/macro";
import { i18n } from '@lingui/core';

export const allowOnly200 = (status: number) => status === 200;

export const authEndpoints = [
  "login",
  "login/microsoft",
  "login/refresh",
  "password/forgot",
  "password/reset",
];

export const microsoftLoginUrl = (
  tenantId: string,
  clientId: string,
  randomState: string,
  redirectUri: string,
  codeChallenge: string
) =>
  `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&response_mode=query&scope=email openid profile offline_access User.Read.All GroupMember.Read.All&state=${randomState}&redirect_uri=${redirectUri}&code_challenge=${codeChallenge}`;

export const appBarFixedHeight = 72;

export const taxonomyViewNoValueText = () => t(i18n)`No value found`;

export const containerMaxWidth = false;

export const expandedBorderColor = "#C7C7C7"

export const messageTextLength = 108;

export const taxonomyImportAllowedFileTypes = [
  "application/x-zip-compressed",
  "application/zip",
];

export const taxonomyDataImportAllowedFileTypes = ["application/xml", "text/xml"];

export const taxonomyImportAllowedFileExtensions = ["zip"];

export const taxonomyDataImportAllowedFileExtensions = ["xsd", "xml"];

export const intendedPathLocalStorageKey = "web_admin_intended_path"

export const customObjectsPagesShouldNotBeMapped = [
  "globals",
  "usage",
  "dimensionValueReferences",
  "taxonomies",
  "extension",
  "childDimensionValues",
  "childElements",
  "documentation",
  "labels",
  "additionalElementReferences",
  "extensionStructureReferences",
  "hierarchyElementReferences",
  "customLabels",
  "customHeaders",
  "customTags",
  "customDimensionValues",
  "dimensionLabels",
  "contexts",
  "valueLabels",
  "validators",
  "childElementReferences",
  "notes",
];

export const filingImportAllowedCountries = [
  {
    "code": "",
    "label": "Select a Country"
  },
  {
    "code": "AT",
    "label": "AUSTRIA"
  },
  {
    "code": "BE",
    "label": "BELGIUM"
  },
  {
    "code": "BG",
    "label": "BULGARIA"
  },
  {
    "code": "CY",
    "label": "CYPRUS"
  },
  {
    "code": "CZ",
    "label": "CZECHIA"
  },
  {
    "code": "DE",
    "label": "GERMANY"
  },
  {
    "code": "DK",
    "label": "DENMARK"
  },
  {
    "code": "EE",
    "label": "ESTONIA"
  },
  {
    "code": "ES",
    "label": "SPAIN"
  },
  {
    "code": "FI",
    "label": "FINLAND"
  },
  {
    "code": "FR",
    "label": "FRANCE"
  },
  {
    "code": "GR",
    "label": "GREECE"
  },
  {
    "code": "HR",
    "label": "CROATIA"
  },
  {
    "code": "HU",
    "label": "HUNGARY"
  },
  {
    "code": "IE",
    "label": "IRELAND"
  },
  {
    "code": "IT",
    "label": "ITALY"
  },
  {
    "code": "LT",
    "label": "LITHUANIA"
  },
  {
    "code": "LU",
    "label": "LUXEMBOURG"
  },
  {
    "code": "LV",
    "label": "LATVIA"
  },
  {
    "code": "MT",
    "label": "MALTA"
  },
  {
    "code": "NL",
    "label": "NETHERLANDS"
  },
  {
    "code": "PL",
    "label": "POLAND"
  },
  {
    "code": "PT",
    "label": "PORTUGAL"
  },
  {
    "code": "RO",
    "label": "ROMANIA"
  },
  {
    "code": "SE",
    "label": "SWEDEN"
  },
  {
    "code": "SI",
    "label": "SLOVENIA"
  },
  {
    "code": "SK",
    "label": "SLOVAKIA"
  }
];

export const filingImportAllowedTaxonomyNames = [
  { "code": "ESEF", "label": "ESEF", }
]
